const collection = {
    slug: "comme-des-garcons-2012ss-white-drama-guide",
    metaTitle:
      "COMME des GARCONS 2012SS WHITE DRAMAとは｜白のドラマとコムデギャルソン買取・レンタルガイド",
    metaDescription:
      "COMME des GARCONS 2012SS『WHITE DRAMA』を解説。白一色の中に、純粋さ、空白、祝祭、拘束、誕生、結婚、死、超越を重ねた重要シーズン。繭状の造形、花、レース、巨大な袖、透明・不透明の素材差から読み解き、COMME des GARCONS買取・レンタルへ。",
    metaKeywords:
      "COMME des GARCONS 2012SS,COMME des GARÇONS 2012SS,コムデギャルソン 2012SS,コムデギャルソン 2012春夏,WHITE DRAMA,Comme des Garcons White Drama,コムデギャルソン WHITE DRAMA,コムデギャルソン ホワイトドラマ,川久保玲 WHITE DRAMA,川久保玲 白,コムデギャルソン 白,コムデギャルソン ドレス,コムデギャルソン レース,コムデギャルソン 繭,コムデギャルソン 花,コムデギャルソン 儀式,コムデギャルソン 名作,COMME des GARCONS 名作,コムデギャルソン アーカイブ,COMME des GARCONS アーカイブ,コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソンオムプリュス 買取,COMME des GARCONS HOMME PLUS 買取,コムデギャルソン レンタル,COMME des GARCONS レンタル,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/comme-des-garcons-2012ss-white-drama-guide",
    heroImage:
      "media/archive_fashion/archive24.png",
    heroImageAlt:
      "COMME des GARCONS 2012SS WHITE DRAMAを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "24 / WHITE DRAMA",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "COMME des GARCONS 2012SS『WHITE DRAMA』",
    lead:
      "COMME des GARCONS 2012SS『WHITE DRAMA』。\n\nこのコレクションを、単に“白いドレス”や“花嫁のイメージ”として読むと、かなり狭くなります。\n\nWHITE DRAMAとは、白という一つの色の中に、複数のドラマを閉じ込めたコレクションです。\n\n白は、無垢の色です。\n白は、始まりの色です。\n白は、祝福の色です。\nしかし同時に、白は空白であり、消失であり、拘束であり、死や喪の気配も持っています。\n\n川久保玲はこのシーズンで、白を一つの意味に固定していません。\n白を、誕生、結婚、祈り、別れ、変容、超越といった複数の場面にまたがる色として扱っています。\n\nだからWHITE DRAMAの服は、ただ清らかではありません。\n美しいのに、少し怖い。\n祝福されているようで、閉じ込められている。\n柔らかいのに、身体の自由を奪う。\n\n繭のようなボリューム。\n花が増殖する表面。\nレースの膜。\n巨大な袖。\n透明と不透明、光沢とマット、硬さと柔らかさ。\n\n白一色でありながら、そこにはいくつもの白があります。\n\nEnclopediaでは、WHITE DRAMAを“白い儀式服”としてだけでなく、白という色が身体に与える心理的な圧力と、服がドラマを生む構造として読み解きます。",
    keywordLine: [
      "white drama",
      "white as drama",
      "ritual body",
      "comme des garcons buyback",
    ],
    thesis:
      "2012SS『WHITE DRAMA』の重要性は、白を純粋さだけに閉じ込めず、空白、祝祭、拘束、誕生、結婚、死、超越といった複数の意味を持つ“ドラマの色”として服に変換した点にあります。",
    whyTitle:
      "WHITE DRAMAとは、何が“ドラマ”だったのか。",
    whyBody:
      "WHITE DRAMAの核心は、“白い服”ではありません。\n\n白という色が、人間の身体にどのような意味を背負わせるのか。\nそこにこのコレクションのドラマがあります。\n\n白は、無垢で何もない色のように見えます。\nしかし実際には、非常に多くの意味を持っています。\n\n生まれたばかりの身体を包む白。\n結婚式で役割を与える白。\n祈りの場で身体を静かにする白。\n死や別れの場面で、身体をこの世界から遠ざける白。\n\n白は、日常の色ではなく、人生の節目に現れる色です。\n\n川久保玲は、その白を一色で見せながら、単調にはしていません。\n花、レース、繭のような丸い造形、大きな袖、透ける素材、厚みのある素材、マットな白、光沢のある白。\n\n白の中に、違う白を重ねている。\n\nその結果、WHITE DRAMAは“白の統一感”ではなく、“白の中で起こる矛盾”として立ち上がります。\n\n清らかなのに、重い。\n祝福のようなのに、不安がある。\n包まれているのに、閉じ込められている。\n見えているのに、隠されている。\n\nこの矛盾こそが、WHITE DRAMAのドラマです。\n\nEnclopediaでは、この文脈を入口に、COMME des GARCONS 2012SSの買取相談、COMME des GARCONS全体のレンタル体験、そしてブランド理解へつなげます。",
    pillars: [
      {
        number: "01",
        title: "WHITE AS CONTRADICTION",
        text:
          "WHITE DRAMAの白は、一つの意味ではありません。純粋さ、空白、祝福、拘束、消失、再生が同時に現れる、矛盾を含んだ色です。",
      },
      {
        number: "02",
        title: "DRAMA WITHOUT COLOR",
        text:
          "色彩ではなく、形、素材、透け感、布量、袖、花、レースによってドラマが作られています。白一色だからこそ、造形の差が強く見えます。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "2012SS WHITE DRAMAは、COMME des GARCONSの中でもテーマ性と造形性が非常に強いシーズンです。買取では白がどのようにドラマを作っているかを確認する必要があります。",
      },
    ],
    readingTitle:
      "白、空白、祝祭、拘束、繭、花、レースから読むCOMME des GARCONS 2012SS。",
    readingIntro:
      "WHITE DRAMAは、花嫁だけのコレクションではありません。白という色が持つ複数の意味を、服の構造で展開したコレクションです。色を削ることで、逆に白の中にある差異が強く見える。透明と不透明、軽さと重さ、柔らかさと拘束、祝福と不安。その矛盾の集積が、このシーズンの“ドラマ”です。",
    observations: [
      {
        index: "01",
        title:
          "WHITE DRAMAの“Drama”は、物語ではなく緊張である",
        text:
          "WHITE DRAMAというタイトルを見ると、白い服で人生の物語を描いたコレクションのように感じるかもしれません。\n\nしかし、このシーズンのドラマは、分かりやすいストーリーではありません。\n\n誕生から結婚、死へ向かう物語を順番に説明するようなものではなく、白という色の中に複数の緊張が同時に置かれている。\n\n無垢なのか。\n拘束なのか。\n祝福なのか。\n不安なのか。\n始まりなのか。\n終わりなのか。\n\nそのどれか一つに決められない状態が、WHITE DRAMAのドラマです。\n\nつまり、Dramaとは“劇的な装飾”ではなく、白の中で意味がぶつかる緊張のことです。",
      },
      {
        index: "02",
        title:
          "白は、何もない色ではなく、意味が多すぎる色である",
        text:
          "白は、しばしば無垢や純粋さの色として扱われます。\n\nしかしWHITE DRAMAを見ると、白はむしろ意味が多すぎる色だと分かります。\n\n産着の白。\n花嫁の白。\n宗教的な白。\n病院の白。\n死装束の白。\n空白の白。\n\n白は、清潔であると同時に、冷たい。\n始まりであると同時に、終わりにも見える。\n\n川久保玲は、その白の複雑さを一つのコレクションに押し込んでいます。\n\nだからWHITE DRAMAは、白いから単純なのではありません。\n白しかないからこそ、見る人は白の意味から逃げられなくなります。",
      },
      {
        index: "03",
        title:
          "色を削ることで、形の違いが強くなる",
        text:
          "WHITE DRAMAは、ほぼ白一色で構成されています。\n\n色の差がないため、普通なら単調になりそうです。\nしかし実際には、むしろ形の違いが強く見えます。\n\n丸い繭のようなボリューム。\n鋭く立つような袖。\n花が増殖する表面。\nレースの穴。\n透ける部分と隠れる部分。\n\n色彩がないぶん、布の厚み、影、凹凸、透過性が前に出る。\n\nWHITE DRAMAの白は、形を見るための装置でもあります。",
      },
      {
        index: "04",
        title:
          "繭のような造形は、変化する直前の身体を作る",
        text:
          "このシーズンには、繭のように身体を包む造形が見られます。\n\n繭は、守るものです。\n同時に、閉じ込めるものでもあります。\n\n中にいる身体は、外から見えにくい。\nしかしその内側では、何かが変化している。\n\nWHITE DRAMAにおける繭状の服は、完成された身体を見せる服ではありません。\n変化する前の身体、まだ別の存在になる途中の身体を作っています。\n\nここでの白は、完成ではなく、変容の途中にある色です。",
      },
      {
        index: "05",
        title:
          "花はロマンティックな装飾ではなく、増殖する白である",
        text:
          "WHITE DRAMAでは、花の装飾が印象的に現れます。\n\nただし、ここでの花は単なるロマンティックな飾りではありません。\n\n白い花は、祝福にも見える。\n祈りにも見える。\n弔いにも見える。\nそして、服の表面で増殖する有機的なものにも見えます。\n\n花が多くなるほど、服は可憐になるだけではなく、どこか過剰になります。\n\nこの過剰さが重要です。\n白い花は、純粋さの象徴でありながら、増えすぎることで不穏にもなる。\n\nWHITE DRAMAの花は、美しさと不安を同時に運んでいます。",
      },
      {
        index: "06",
        title:
          "レースは、肌を見せるためではなく、身体を遠ざける膜である",
        text:
          "レースは一般的には、肌を見せるための装飾として扱われることがあります。\n\nしかしWHITE DRAMAのレースは、むしろ身体を遠ざける膜として働いています。\n\n完全に隠すわけではない。\nしかし、直接見せるわけでもない。\n\n身体と見る人の間に、白いフィルターが入る。\n\nその結果、身体は日常的な身体ではなくなります。\n触れられる身体ではなく、儀式の中に置かれた身体になる。\n\nWHITE DRAMAのレースは、性的な装飾よりも、距離を作るための素材です。",
      },
      {
        index: "07",
        title:
          "巨大な袖は、身体の機能を隠す",
        text:
          "このシーズンでは、巨大な袖や手を覆うような構造も印象的です。\n\n手は、選ぶ、触れる、働く、動かすための部位です。\nその手が隠れると、身体は急に受け身になります。\n\n自由に動く身体ではなく、何かの役割を与えられた身体に見える。\n\nWHITE DRAMAの袖は、単なるボリュームではありません。\n身体の機能を隠すことで、服を着る人を日常から切り離しています。\n\n白い服はここで、身体を飾るものではなく、身体の自由を制限するものになります。",
      },
      {
        index: "08",
        title:
          "透明と不透明の差が、白の中に奥行きを作る",
        text:
          "WHITE DRAMAは白一色に見えます。\nしかしよく見ると、その白は均一ではありません。\n\n透ける白。\n隠す白。\n光る白。\nマットな白。\n軽い白。\n重い白。\n\n同じ白でも、素材の違いによって身体との距離が変わります。\n\n透明な白は、身体を近づける。\n不透明な白は、身体を遠ざける。\n厚い白は、身体を隠す。\n軽い白は、空気を含む。\n\nこの差によって、WHITE DRAMAは白一色でありながら、非常に多層的に見えます。",
      },
      {
        index: "09",
        title:
          "花嫁ではなく、“白を着せられた身体”として見る",
        text:
          "WHITE DRAMAを花嫁のイメージだけで読むと、2005AW Broken Brideのような文脈に引っ張られすぎます。\n\nこのシーズンで重要なのは、壊れた花嫁ではありません。\n\nもっと広く、“白を着せられた身体”です。\n\n白を着ることで、身体は別の役割を持ち始めます。\n花嫁にも見える。\n幼児にも見える。\n祈る人にも見える。\n弔われる人にも見える。\n人間ではなく、繭や花のようにも見える。\n\nつまりWHITE DRAMAの身体は、一つの役割に固定されません。\n白によって、複数の存在に変化していくのです。",
      },
      {
        index: "10",
        title:
          "心理的に強いのは、“白なのに安心できない”こと",
        text:
          "WHITE DRAMAが記憶に残る理由は、白が安心できる色として使われていないからです。\n\n白は本来、清潔、純粋、明るさを連想させます。\nしかしこのコレクションでは、白が過剰になることで、むしろ不安が生まれます。\n\n白い花が増えすぎる。\n白い布が身体を覆いすぎる。\n白い袖が手を隠す。\n白いレースが身体との距離を作る。\n\n安心の色が、少し怖くなる。\n\nこの認知的不協和が、見る人を引き込みます。\n美しいのに落ち着かない。\n清らかなのに息苦しい。\n\nWHITE DRAMAの強さは、この心理的な揺れにあります。",
      },
      {
        index: "11",
        title:
          "“分からないけれど忘れられない”白が、アーカイブ価値になる",
        text:
          "強いアーカイブは、一目で説明できるものばかりではありません。\n\nWHITE DRAMAもそうです。\n\n白い。\n美しい。\nしかし、それだけでは終わらない。\n\n何の儀式なのか。\n誰のための服なのか。\n祝福なのか、拘束なのか。\n始まりなのか、終わりなのか。\n\n見る人の中に問いが残ります。\n\nこの未完了感が、記憶に残る理由です。\n完全に理解できる服よりも、少し分からない服のほうが、後から何度も思い出される。\n\nWHITE DRAMAは、白によって問いを残すコレクションです。",
      },
      {
        index: "12",
        title:
          "買取で見るべきなのは、白い服かどうかではない",
        text:
          "COMME des GARCONS 2012SS WHITE DRAMAの買取では、単に白い服だから価値がある、という見方では不十分です。\n\n2012SSに該当するか。\nWHITE DRAMAらしい白の緊張感があるか。\n繭のようなボリューム、花、レース、巨大な袖、透明と不透明の素材差があるか。\n白の黄ばみ、汚れ、変色、レースの傷み、装飾欠損、保管状態はどうか。\n\nこのシーズンは、白であること以上に、白がどのようにドラマを作っているかが重要です。\n\nEnclopediaでは、COMME des GARCONSを単なるブランド古着としてではなく、シーズン背景、造形、状態、現在の需要まで含めて確認します。",
      },
      {
        index: "13",
        title:
          "レンタルで分かるのは、白が身体に与える圧力である",
        text:
          "WHITE DRAMAのような服は、画像だけでは理解しきれません。\n\n白の圧力。\n布の量。\n袖の大きさ。\n身体が隠れる感覚。\nレースや花との距離。\n透明な白と不透明な白の違い。\n\n実際に着ることで、白が身体を軽く見せるだけではなく、身体に役割や緊張を与えることが分かります。\n\nEnclopediaでは、記事で背景を読み、レンタルで身体感覚として確かめる導線を作ります。",
      },
    ],
    quote:
      "WHITE DRAMAとは、白の美しさではない。白が身体に意味を背負わせ、安心と不安を同時に生む、その緊張のことです。",
    perspectiveTitle:
      "Enclopediaは、COMME des GARCONSを“白い服”ではなく“白が身体にドラマを起こすアーカイブ”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "2012SS WHITE DRAMAを、白、空白、祝祭、拘束、繭、花、レース、透明と不透明の素材差から読み解き、川久保玲が作った白の意味を整理します。",
      },
      {
        number: "02",
        title: "EXPERIENCE",
        text:
          "WHITE DRAMAの服は、実際に着ることで理解が深まります。白の圧力、布量、身体の隠れ方、花やレースとの距離をレンタルで体験できます。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "2012SS、WHITE DRAMA、花、レース、繭状の造形、巨大な袖、白の状態を確認することで、COMME des GARCONSの一着がアーカイブとしてどう評価されるのかが見えてきます。",
      },
    ],
    experienceTitle:
      "COMME des GARCONS 2012SS WHITE DRAMAを売る前に、その一着がどの“白のドラマ”を持つかを確認する。",
    experienceBody:
      "COMME des GARCONS 2012SS WHITE DRAMAの買取では、ブランド名だけでなく、シーズン、テーマ、造形、素材、状態、サイズ、現在の需要が重要です。\n\n特にWHITE DRAMA期は、白一色の構成、繭のようなボリューム、花、レース、巨大な袖、透明と不透明の素材差、身体を包む構造など、視覚的な強度と象徴性が重なります。\n\nまた、白いアイテムは状態確認が非常に重要です。\n黄ばみ、汚れ、変色、レースの傷み、花装飾の欠損、保管時の跡などが価値に影響します。\n\nEnclopediaが見ているのは2012SSだけではありません。\nCOMME des GARCONS、COMME des GARCONS HOMME PLUS、COMME des GARCONS HOMME、JUNYA WATANABE、BLACK COMME des GARCONSなど、コムデギャルソン全体を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n\nWHITE DRAMAを知ることは、自分の持っている一着が“ただの白い服”なのか、“COMME des GARCONSの白のドラマを残すアーカイブ”なのかを見極める入口になります。",
    experienceItems: [
      "COMME des GARCONS 2012SS WHITE DRAMAのタグ・AD表記・シーズンを確認する",
      "WHITE DRAMAに近い白いドレス、ジャケット、スカート、コート、造形的なアイテムを撮影する",
      "繭のようなボリューム、花、レース、巨大な袖、身体を包む構造の有無を確認する",
      "透明な白、不透明な白、光沢のある白、マットな白など素材差を確認する",
      "白の黄ばみ、汚れ、変色、保管跡、レースの傷み、装飾欠損を確認する",
      "素材表記、品質タグ、サイズ、購入時期、付属品を確認する",
      "2012SSか不明な場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "2012SS WHITE DRAMAを入口に、COMME des GARCONSの買取・レンタルへ。",
    archiveItemsBody:
      "Enclopediaでは、COMME des GARCONSを単なるブランド古着としてではなく、川久保玲の身体への問い、シーズン背景、造形性、素材、現在の需要まで含めて見ています。この記事でWHITE DRAMAの重要性に触れた方は、所有しているCOMME des GARCONSの一着も、まずはLINEでご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "COMME des GARCONS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons",
        productImage: "",
        text:
          "2012SS WHITE DRAMAを含むCOMME des GARCONSのドレス、ジャケット、コート、スカート、造形的なアーカイブまで。コムデギャルソンの買取対象と査定視点を確認できます。",
      },
      {
        label: "BUYBACK FOCUS 02",
        title: "COMME des GARCONS HOMME PLUS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons-homme-plus",
        productImage: "",
        text:
          "COMME des GARCONS HOMME PLUSのジャケット、パンツ、コート、シーズンテーマの強いアーカイブまで。オムプリュスの買取相談にも進めます。",
      },
      {
        label: "RENTAL FOCUS 03",
        title: "レンタルできるCOMME des GARCONSを見る",
        productPath:
          "/brand/COMME%20DES%20GARCONS（コムデギャルソン）/?number=10",
        productImage: "",
        text:
          "COMME des GARCONSの造形性やシーズン性は、実際に着ることで理解が深まります。Enclopediaでコムデギャルソンのアーカイブを体験できます。",
      },
      {
        label: "LINE FOCUS 04",
        title: "WHITE DRAMAを読んだら、次はCOMME des GARCONSの価値を相談する",
        productPath:
          "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "2012SS、WHITE DRAMA、白、花、レース、繭状の造形、巨大な袖、素材差、状態が分かる写真をLINEでお送りください。Enclopediaが文脈込みで確認します。",
      },
    ],
    finalCta: {
      title:
        "WHITE DRAMAを読んだら、次はCOMME des GARCONSの価値を相談する。",
      body:
        "COMME des GARCONS 2012SS『WHITE DRAMA』は、白を美しさのためだけに使ったコレクションではありません。\n白という色が持つ純粋さ、空白、祝祭、拘束、不安、変容を、造形服として表現した重要シーズンです。\n\nEnclopediaでは、2012SSの買取相談を入口に、COMME des GARCONS全体のレンタル体験や買取相談へつなげます。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
      buttonLabel: "COMME des GARCONSをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;